export const ScrumStatuses = {
  TODO: "To Do",
  IN_PROGRESS: "In Progress",
  IN_QA: "In QA",
  DONE: "Done",
};

export const SprintStatuses = {
  NOT_STARTED: "Not Started",
  CURRENT: "Current",
  COMPLETED: "Completed",
};

export const ApprovalStatuses = {
  PENDING: "Pending",
  REJECTED: "Rejected",
  APPROVED: "Approved",
};

export const TicketStatuses = {
  DRAFT: "Draft",
  TO_DO: "To Do",
  IN_QA: "In Qa",
  IN_PROGRESS: "In Progress",
  DONE: "Done",
  IN_APPROVAL: "In Approval",
  REJECTED: "Rejected",
  SENT_FOR_CONFIRMATION: "Sent For Confirmation",
  CONFIRMATION_REJECTED: "Confirmation Rejected"
};

export const ProjectStatuses = {
  DRAFT: "Draft",
  ONGOING: "Ongoing",
  COMPLETED: "Graduated",
  SENT_FOR_CONFIRMATION: "Sent For Confirmation",
  CONFIRMATION_REJECTED: "Confirmation Rejected",
  IN_APPROVAL: "In Approval",
   PENDING: "Pending",
  REJECTED: "Rejected",
  // GRADUATED: "Graduated",
};

export const TechnologySector = {
  HELATH_SECTOR: "Health Sector",
  SUSTAINABILIY_ENVIRONMENT_SECTOR: "Sustainability and Environment Sector",
  ENERGY_INDUSTRY_SECTOR: "Energy and Industry Sector",
  FUTURE_ECONOMY_SECTOR: "Future Economies Sector"
}

export const MilestoneStatus = {
  DRAFT: "Draft",
  ONGOING: "Ongoing",
  DONE: "Done",
  IN_APPROVAL: "In Approval",
  REJECTED: "Rejected",
  SENT_FOR_CONFIRMATION: "Sent For Confirmation",
  CONFIRMATION_REJECTED: "Confirmation Rejected"
};

export const DeliverableStatus = {
  DRAFT: "Draft",
  ONGOING: "Ongoing",
  DONE: "Done",
  IN_APPROVAL: "In Approval",
  REJECTED: "Rejected",
  SENT_FOR_CONFIRMATION: "Sent For Confirmation",
  CONFIRMATION_REJECTED: "Confirmation Rejected",
  SUBMITTED: 'Submitted',
}

export const ProjectDeliverableStatus = {
  ONGOING: 'Ongoing',
  IN_APPROVAL: 'In Approval',
  REJECTED: 'Rejected',
  DELAYED: 'Delayed',
  APPROVED: 'Approved',
};

export const ChangeRequestStatus = {
  DRAFT: 'Draft',
  IN_APPROVAL: 'In Approval',
  REJECTED: 'Rejected',
  APPROVED: 'Approved'
}

export const WorkshopType = [
    "Workshop",
    "Event",
];

export const AttendanceType = {
  ATTENDANCE: 'attendance',
  LATE_ATTENDANCE: 'late_attendance',
  ATTENDANE_WITH_EXCUSE: 'attendance_with_excuse',
  ATTENDANCE_WITHOUT_EXCUSE: 'attendance_without_excuse'
}
